import styled from "styled-components";

import {
  BRAND,
  BRAND_DARK,
  GRAY,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  WHITE
} from "../../colors";
import { LARGE_SCREEN } from "../../constants/screenSizes";
import { Body } from "../../typography";
import { checkmark } from "../assets";

const TRANSITION_DURATION = "300ms";

export const Checkbox = styled.input.attrs({
  type: "checkbox"
})`
  appearance: none;
  background-color: ${WHITE};
  border: 1px solid ${GRAY};
  border-radius: 2px;
  height: 20px;
  margin: 0 12px -1px 0;
  padding: 0;
  vertical-align: text-bottom;
  width: 20px;
  transition: background-color ${TRANSITION_DURATION},
    border-color ${TRANSITION_DURATION};

  &:checked {
    background-color: ${BRAND};
    background-image: url(${checkmark});
    background-position: center;
    background-repeat: no-repeat;
    border-color: ${BRAND};
  }

  &:disabled {
    background-color: ${GRAY_LIGHT};
    background-image: none;
    border-color: ${GRAY_LIGHT};
    transition: none;
  }

  &:focus {
    outline: none;

    &:after {
      content: "";
      border: 2px solid ${BRAND_DARK};
      border-radius: 5px;
      box-sizing: content-box;
      height: 24px;
      left: 6px;
      position: absolute;
      top: 5px;
      width: 24px;

      @media screen and (max-width: ${LARGE_SCREEN}px) {
        top: 7px;
      }
    }
  }
`;

export const Label = styled(Body).attrs({ as: "label" })`
  * {
    box-sizing: border-box;
  }

  background-color: transparent;
  display: block;
  padding: 8px 16px 8px 10px;
  position: relative;
  transition: background-color ${TRANSITION_DURATION};

  &:hover {
    background-color: ${({ disabled }) =>
      disabled ? "transparent" : GRAY_LIGHTEST};
    border-radius: 4px;
    cursor: ${({ disabled }) => (disabled ? "initial" : "pointer")};
  }
`;
